exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "#diagram3b3-6 .element{padding:4px 2px}#diagram3b3-6 #slots div[id],#diagram3b3-6 .element{height:104px;width:168px}#diagram3b3-6 #slots #slot_6_1{margin-bottom:0}#diagram3b3-6 #slots .slots-addbox{top:487px}#diagram3b3-6 .move-first-element{transform:translate(268px,-436px)}#diagram3b3-6 .move-second-element{transform:translate(-12px,-631px)}#diagram3b3-6 .move-third-element{transform:translate(-693px,-436px)}#diagram3b3-6 #elements{margin-top:204px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./client/app/components/diagrams/3/3b3/diagram6/diagram6.scss
// module id = 1252
// module chunks = 0